import { LOCALE_ID, NgModule } from '@angular/core';
import { IntlModule, localeData, Locale } from "@progress/kendo-angular-intl";
// Load all required data for the es locale
import "@progress/kendo-angular-intl/locales/es/all";

import { BrowserModule } from '@angular/platform-browser';
import { AppComponent } from '@app/app.component';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { NavigationModule } from "@progress/kendo-angular-navigation";
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ServiceWorkerModule } from '@angular/service-worker';
import { LayoutModule } from '@progress/kendo-angular-layout';
import { ListViewModule } from '@progress/kendo-angular-listview';
import { UploadInterceptor } from '@app/core/interceptors';
import { 
        VehicleCardComponent,
        ServiceCardComponent,
        ExpenseCardComponent,
        CustomerCardComponent,
        CreditCardComponent,
        CreditDetailCardComponent,
        CreditPaymentCardComponent,
        ReceiptCardComponent,

        VehicleHistoryCardComponent
} from "@app/components/cards";
import { DynamicAutocompleteComponent } from '@app/components/autocompletes';
import { DynamicDropdownlistComponent } from '@app/components/dropdownlists';
// import { 
//         SelectorWeekComponent      
// } from "@app/components/selectors";
import { 
        VehicleFilterComponent,
        ServiceFilterComponent
} from "@app/components/filters";
import { 
        VehicleInfoComponent,
        CustomerInfoComponent,
        DiarioInfoComponent,
        SubtotalInfoComponent
} from "@app/components/infos";
import { 
        PasswordInputComponent,
} from "@app/components/inputs";
import { 
        VehicleMenuComponent
} from "@app/components/menus";
import { 
        ImagesScrollviewComponent
} from "@app/components/scrollviews";
import { 
        MultipleImagenUploadComponent
} from "@app/components/uploads";
import { 
        LoginComponent, 
        HomeComponent, 
        ProfileComponent, 

        ServicesComponent,
        ServiceActionsComponent,
        ServiceReceptionComponent,

        ExpensesComponent,
        ExpenseActionsComponent,

        CustomersComponent,
        CustomerActionsComponent,
        CustomerCreditsComponent,

        CreditsComponent,

        HistoryComponent,

        VehiclesComponent, 
        VehicleActionsComponent,
        VehicleEditCostComponent,
        VehicleEditPhotosComponent
} from "@app/pages";
import { IndicatorsModule } from '@progress/kendo-angular-indicators';
import { IconsModule } from '@progress/kendo-angular-icons';
import { RouterModule } from '@angular/router';
import { GridModule } from '@progress/kendo-angular-grid';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { LabelModule } from '@progress/kendo-angular-label';
import { ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';
// import { SocketIoModule, SocketIoConfig } from 'ngx-socket-io';

import { environment } from '@environments/environment';
import "@progress/kendo-date-math/tz/America/Mexico_City";
import { NotificationModule } from '@progress/kendo-angular-notification';
import { DialogsModule } from '@progress/kendo-angular-dialog';
import { UploadsModule } from '@progress/kendo-angular-upload';
import { ScrollViewModule } from '@progress/kendo-angular-scrollview';


const esData: Locale = localeData(environment.locale);
if(esData) {
  esData!.numbers!.symbols!.decimal = ".";
  esData!.numbers!.symbols!.group = ",";
  esData!.calendar!.days!.format!.short = [
    "Do",
    "Lu",
    "Ma",
    "Mi",
    "Ju",
    "Vi",
    "Sa"
  ];
  esData!.calendar!.months!.format!.abbreviated = [
    "Ene",
    "Feb",
    "Mar",
    "Abr",
    "May",
    "Jun",
    "Jul",
    "Ago",
    "Sep",
    "Oct",
    "Nov",
    "Dic"
  ];
  esData!.calendar!.months!.format!.wide = [
    "Enero",
    "Febrero",
    "Marzo",
    "Abril",
    "Mayo",
    "Junio",
    "Julio",
    "Agosto",
    "Septiembre",
    "Octubre",
    "Noviembre",
    "Diciembre"
  ]
}

// const config: SocketIoConfig = { 
//   url: environment.wsUrl, 
//   options: {} 
// };

const bottomNavigationRoutes = [
  { path: 'home', component: HomeComponent, text: 'Inicio', image: 'assets/buttons/home.png' },
  { path: '', component: LoginComponent, text: 'Login', image: '' },
  { path: 'login', component: LoginComponent, text: 'Login', image: '' },  

  { path: 'services', component: ServicesComponent, text: 'Servicios', image: '' },
  { path: 'service_new', component: ServiceActionsComponent, text: 'Servicio - Nuevo', image: '', data: {mode: 'CREATE'} },
  { path: 'service_edit/:id', component: ServiceActionsComponent, text: 'Servicio - Editar', image: '', data: {mode: 'EDIT'} },
  { path: 'service_reception/:id', component: ServiceReceptionComponent, text: 'Servicio - Recepción', image: '', data: {mode: 'RECEPTION'} },

  { path: 'expenses', component: ExpensesComponent, text: 'Gastos', image: '' },
  { path: 'expense_new', component: ExpenseActionsComponent, text: 'Gasto - Nuevo', image: '', data: {mode: 'CREATE'} },
  { path: 'expense_edit/:id', component: ExpenseActionsComponent, text: 'Gasto - Editar', image: '', data: {mode: 'EDIT'} },

  { path: 'vehicles', component: VehiclesComponent, text: 'Vehículos', image: 'assets/buttons/vehicle.png' },
  { path: 'vehicle_actions/:id', component: VehicleActionsComponent, text: 'Vehículo - Editar', image: '' },
  { path: 'vehicle_cost/:id', component: VehicleEditCostComponent, text: 'Vehículo - Editar Costo', image: '' },
  { path: 'vehicle_photos/:id', component: VehicleEditPhotosComponent, text: 'Vehículo - Editar Fotos', image: '' },

  { path: 'customers', component: CustomersComponent, text: 'Clientes', image: '' },
  { path: 'customer_new', component: CustomerActionsComponent, text: 'Cliente - Nuevo', image: '', data: {mode: 'CREATE'} },
  { path: 'customer_edit/:id', component: CustomerActionsComponent, text: 'Cliente - Editar', image: '', data: {mode: 'EDIT'} },
  { path: 'customer_credits/:id', component: CustomerCreditsComponent, text: 'Cliente - Créditos', image: '' },
  // { path: 'vehicle_cost/:id', component: VehicleEditCostComponent, text: 'Vehículo - Editar Costo', image: '' },
  // { path: 'vehicle_photos/:id', component: VehicleEditPhotosComponent, text: 'Vehículo - Editar Fotos', image: '' },

  { path: 'history', component: HistoryComponent, text: 'Historial', image: 'assets/buttons/history.png' },
  { path: 'credits', component: CreditsComponent, text: 'Créditos', image: '' },
  // { path: 'config', component: ConfigComponent, text: 'Historial', image: 'assets/buttons/history.png' },

  { path: 'profile', component: ProfileComponent, text: 'Perfil', image: 'assets/buttons/profile.png' }, 
];

import { SocketIoModule, SocketIoConfig } from 'ngx-socket-io';
 
const config: SocketIoConfig = { url: environment.wsUrl, options: {} };


@NgModule({
  declarations: [
    AppComponent, 
    
    LoginComponent, 
    HomeComponent, 
    ProfileComponent, 
    
    ServicesComponent,
    ServiceActionsComponent,
    ServiceReceptionComponent,

    ExpensesComponent,
    ExpenseActionsComponent,

    HistoryComponent,

    CustomersComponent,
    CustomerActionsComponent,
    CustomerCreditsComponent,

    CreditsComponent,

    VehiclesComponent,
    VehicleActionsComponent,
    VehicleEditCostComponent,
    VehicleEditPhotosComponent,

    VehicleMenuComponent,

    DynamicAutocompleteComponent,
    
    DynamicDropdownlistComponent,

    VehicleCardComponent,
    ServiceCardComponent,    
    ExpenseCardComponent,
    CustomerCardComponent,
    CreditCardComponent,
    CreditDetailCardComponent,
    CreditPaymentCardComponent,
    ReceiptCardComponent,

    VehicleHistoryCardComponent,
    // SelectorWeekComponent,

    VehicleFilterComponent,
    ServiceFilterComponent,

    VehicleInfoComponent,
    CustomerInfoComponent,
    DiarioInfoComponent,
    SubtotalInfoComponent,

    MultipleImagenUploadComponent,

    PasswordInputComponent,

    ImagesScrollviewComponent
  ],
  imports: [
    BrowserModule,
    DropDownsModule,
    NavigationModule,
    BrowserAnimationsModule,
    ReactiveFormsModule,
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: environment.production,
      // Register the ServiceWorker as soon as the app is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerImmediately'
    }),
    RouterModule.forRoot(bottomNavigationRoutes),
    LayoutModule,
    ListViewModule,
    IndicatorsModule,
    IconsModule,
    GridModule,
    InputsModule,
    LabelModule,
    HttpClientModule,
    ButtonsModule,
    DateInputsModule,
    IntlModule,
    // SocketIoModule.forRoot(config),
    NotificationModule,
    DialogsModule,
    UploadsModule,
    ScrollViewModule,
    SocketIoModule.forRoot(config)
  ],
  providers: [
    { provide: LOCALE_ID, useValue: environment.locale},
    { provide: HTTP_INTERCEPTORS, useClass: UploadInterceptor, multi: true },
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
